module.exports = __webpack_public_path__ + "static/img/ai1.da79dee7.jpg";